
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 17a6.99 6.99 0 01-7-7c0-3.873 3.126-7 7-7s7 3.127 7 7c0 3.874-3.126 7-7 7zm-8-7c0 4.426 3.574 8 8 8s8-3.574 8-8-3.574-8-8-8a7.99 7.99 0 00-8 8z","fill":"#1A1A1F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.328 11.07l.172-5h-1l.137 5h.69z","fill":"#1A1A1F"}}),_c('path',{attrs:{"d":"M10.5 13.43a.5.5 0 10-1 0 .5.5 0 001 0z","fill":"#1A1A1F"}})])
      }
    
      }
    